import http from "../../../services/httpService";
import { injectHtml } from "../../../utils/htmlUtil";
import { error, isEmpty } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import { bindSearchAutocomplete, noResultHtml } from "../../common/autocomplete";
import { openSnackbar, snackbarModel } from "../../common/snackbar";
import { reloadProductBundleCollectionDatatable } from "../../datatables/dtAdminProductBundleCollectionManagement";

const props = {
    variantCollectionWrapper: '.variant-collection-wrapper',
    productCollectionId: '.product-picker-editor-product-collection-id',
    productCollectionPickerWrapper: '#product-collection-picker-editor-wrapper',
    productCollectionPickerWrapperId: 'product-collection-picker-editor-wrapper'
};

export function initAdminProductBundleCollectionPicker() {

    if ($(props.variantCollectionWrapper).length) {

        //NOTE: only product addition is handled in this file. Reordering, deletions etc is handled in adminProductBundleCollectionManagement.
        $(props.variantCollectionWrapper).each(function (i, obj) {

            bindProductBundleCollectionPickerEvents($(this));
        });
    }
}

function bindProductBundleCollectionPickerEvents(variantCollectionWrapperParent) {

    //bind autocomplete events
    initProductSearchAutoComplete(variantCollectionWrapperParent);
}

async function initProductSearchAutoComplete(variantCollectionWrapperParent) {

    catchError(async function () {

        var containerEntity = variantCollectionWrapperParent.find('.search-container-with-autocomplete');
        var containerId = '#' + containerEntity.attr('id');
        var productCollectionId = variantCollectionWrapperParent.data('variant-collection-id');
        var productCollectionTable = variantCollectionWrapperParent.find('.product-collection-table');

        const autoComplete = containerEntity.find('.search-autocomplete');


        bindSearchAutocomplete(containerId, async function (outputSearchTerm) {

            const data = {
                searchTerm: outputSearchTerm,
                productCollectionId: productCollectionId,
            };

            const result = await getSearchProductsAutocompleteHtml(data);

            const isDataEmpty = isEmpty(result);

            if (isDataEmpty) return injectHtml(autoComplete, noResultHtml);

            await injectHtml(autoComplete, result);

            $(autoComplete).find('.autocomplete-item').off('click').on('click', async function (e) {

                //post back, saving the selected benefit against the product. reload the relevant table when complete.
                const selectedProductVariantId = $(this).data('id');

                const selectedProductVariantData = {
                    productCollectionId: productCollectionId,
                    productVariantId: selectedProductVariantId
                };

                var result = await addProductCollectionItemService(selectedProductVariantData);

                reloadProductBundleCollectionDatatable(productCollectionTable.attr('id'));

                if (result.responseResult === "NONE") {

                    //display confirmation message to the user
                    openSnackbar({
                        ...snackbarModel,
                        content: result.responseMessage
                    });
                }
                else {

                    //display error / warning message to the user
                    openSnackbar({
                        ...snackbarModel,
                        content: result.responseMessage,
                        theme: 'error'
                    });
                }

            });
        });
    });
}



//API CALLS

async function getSearchProductsAutocompleteHtml(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productpickermanagement/searchproductcollectionlistitems', data);
    // The response is an object with a property called 'data'. This contains the HTML.
    return response.data;
}

async function addProductCollectionItemService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/productpickermanagement/addproductcollectionitem', data);
    // The response is an object with a property called 'data'. 
    return response.data;
}
